<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <BusinessSegmentTableItem v-for="item in businessSegmentGrid" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import BusinessSegmentTableItem from 'components/setting/businessSegment/BusinessSegmentTableItem'
export default {
  name: 'BusinessSegmentTable',
  props: ['businessSegmentGrid'],
  components: { BusinessSegmentTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-business_segment'].tables[
            'nazvanie-segmenta'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
